export const forkJoin = async <T extends { [key: string]: Promise<any> }>(
    requests: T
): Promise<{ [K in keyof T]: any }> => {
    try {
        const entries = Object.entries(requests) as [keyof T, Promise<any>][];
        const results = await Promise.all(entries.map(([_, request]) => request));

        return entries.reduce((acc, [key], index) => {
            const result = results[index];
            acc[key] = result && result.data !== undefined ? result.data : result;
            return acc;
        }, {} as { [K in keyof T]: any });
    } catch (error) {
        throw error;
    }
};
